import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import { UserData, LoginResponse, LoginForm } from 'src/app/class/datatype';
import { clearCashierStorage } from 'src/app/services/cashier/cashier-storage';

@Injectable()
export class AuthService {
  public user: UserData;
  public permissions: string[] = [];

  constructor(private http: HttpClient, private jwtHelper: JwtHelperService) {
    this.user = JSON.parse(window.sessionStorage.getItem('lccore_user'));
    this.permissions = JSON.parse(
      window.sessionStorage.getItem('lcore_permissions')
    );
  }

  login(data: LoginForm): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(
      environment.apiUrl + 'client/login',
      data
    );
  }

  public setAuthData(data: LoginResponse) {
    window.sessionStorage.setItem('lccore_token', data.token);
    window.sessionStorage.setItem('lccore_user', JSON.stringify(data.user));
    window.sessionStorage.setItem(
      'lcore_permissions',
      JSON.stringify(data.permissions)
    );

    this.user = data.user;
    this.permissions = data.permissions;
  }

  public clearAuthData() {
    window.sessionStorage.removeItem('lccore_token');
    window.sessionStorage.removeItem('lccore_user');
    window.sessionStorage.removeItem('lcore_permissions');
    clearCashierStorage();

    this.user = null;
    this.permissions = [];
  }

  public isAuthenticated(): boolean {
    const token = this.jwtHelper.tokenGetter();
    // Check whether the token is expired and return
    // true or false
    if (token) {
      return !this.jwtHelper.isTokenExpired(token);
    }

    return false;
  }

  public isAllowed(access: string[]): boolean {
    const tmp: string[] = [];

    access.forEach((n) => {
      if (!this.permissions.includes(n)) {
        tmp.push(n);
      }
    });

    if (tmp.length > 0) {
      return false;
    }

    return true;
  }
}
